import React, { useState } from 'react';

import OverlayWaiting from '../../components/Notification/OverlayWaiting'
import DropDownShow from '../../components/Filter/DropDownShow';
import streamingLinksService from '../../services/streamingLinksService';
import { useGlobalContext } from '../../services/globalContext';
import { useDownloadFile } from '../../hooks/useDownloadFile';

import { Col, Row, Card, CardBody, FormGroup, Badge, Button, CardHeader, Form, Alert } from 'reactstrap';


const StreamingLinks = () => {
    const globalContext = useGlobalContext();
    const [show, setShow] = useState(globalContext.show || "");
    const [downloading, setDownloading] = useState(false);

    const showChangeHandler = (nextShow) => {
        setShow(nextShow);
        globalContext.show = nextShow;
    }

    const buttonDisabled = (show == null || show == "" || downloading);

    const preDownloading = () => {
        setDownloading(true);
    };
    const postDownloading = () => {
        setDownloading(false);
    };
    const onErrorDownloadFile = () => {
        setDownloading(false);
    };

    const getFileName = () => `StreamingLinks_${show}_${new Date().toLocaleString()}.csv`;

    const downloadSampleCsvFile = () => {
        return streamingLinksService.get(show);
    };

    const { ref, url, download, name } = useDownloadFile({
        apiDefinition: downloadSampleCsvFile,
        preDownloading,
        postDownloading,
        onError: onErrorDownloadFile,
        getFileName,
    });

    return (
        <>  {downloading && <OverlayWaiting message="The file will be downloaded automatically once generated." /> }
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <h3>This page allows to export all file names and streaming URL from Limelight for a particular show.</h3>
                        </CardHeader>
                        <CardBody>
                            <Alert color="warning">This process can take a few minutes to complete.</Alert>

                            <Form>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <DropDownShow show={show} onShowChanged={showChangeHandler} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <a href={url} download={name} className="hidden" ref={ref} />
                                            <Button
                                                disabled={buttonDisabled}
                                                color="primary"
                                                onClick={event => download(event.target.value)}>Get Streaming Links</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>

                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default StreamingLinks;